import styled from "@emotion/styled";
import { baseGray200, baseWhite } from "styleConstants";

export const LeadActionButtonsStyles = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  padding: 10px 16px;
  border-top: 1px solid ${baseGray200};
  background: ${baseWhite};

  & > div {
    flex-grow: 1;
  }

  button:last-child {
    margin-left: 16px;
  }
`;

export const LeadManagementStyled = styled.div`
  border-radius: 8px;
  border: 1px solid ${baseGray200};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 88%;
  display: flex;
  flex-direction: column;
  max-height: 90vh; /* Add max-height to prevent overflow */
  overflow: hidden; /* Prevent content from flowing outside */

  .lead-page {
    flex-grow: 1;
    max-height: 587px; /* Increased from 547px to accommodate the pilot banner */
    height: auto; /* Change from fixed height to auto */
    min-height: 547px; /* Keep minimum height the same */
    overflow: auto; /* Add scrolling if content exceeds the container */

    & > div:first-of-type {
      border-right: 1px solid ${baseGray200};
    }

    &__step {
      width: 100%;
      min-width: 480px;
    }

    &__section__wrapper {
      max-height: calc(100% - 65px - 61px);
      height: 100%;
      overflow: auto; /* Add scrolling capability */
    }

    & > div:first-of-type {
      max-width: calc(100% - 300px);
    }

    .notes-parent-container,
    .disposition-parent-container,
    &__menu {      
      width: 250px;
      min-width: 180px;
    }

    .notes-parent-container,
    .disposition-parent-container {
      justify-content: space-between;
      display: flex;
      flex-direction: column;
    }

    &._setter {
      & > div:first-of-type {
        max-width: 50%;
      }
      .notes-parent-container {
        max-width: unset;
        width: unset;
      }
    }

    & > div {
      flex-grow: 1;
    }

    &__main {
      height: 100%;
    }
  }
`;

export const FormStyled = styled.div`
  padding: 10px;
  background: ${baseWhite};

  .error-tooltip {
    background-color: #F05252;
  }

  & > div {
    flex-wrap: wrap;
  }

  &.info-form {
    overflow: auto;
    box-sizing: border-box;
    height: 100%;
    display: flex;
    @media (min-width: 1100px) and (max-width: 1366px) {
      justify-content: flex-start;
    }
    @media (min-width: 1366px) {
      justify-content: center;
    }
  }

  .info-form {
    &__form-group {
      margin-bottom: 16px;
      flex-basis: 50%;
      max-width: 50%;
      box-sizing: border-box;

      &__block-label {
        border-top: 1px solid ${baseGray200};
      }

      &._no-border {
        .info-form__form-group__block-label {
          border: none;
          padding-top: 0;
        }
      }

      &._m-top {
        margin-top: 16px;
      }

      &._small-field {
        flex-basis: 25%;
        max-width: 25%;
      }

      &._large-field {
        flex-basis: 100%;
        max-width: 100%;
      }

      &._p-left {
        padding-left: 8px;
      }

      &._p-right {
        padding-right: 8px;
      }
      
      &._p-bottom {
        padding-bottom: 20px;
        margin-bottom: 30px;
      }

      &._medium-field {
        flex-basis: calc(100% / 3);
        max-width: calc(100% / 3);
      }

      &._double-padding {
        padding-right: 8px !important;
        padding-left: 8px !important;
      }

      &._no-padding {
        padding-right: 0 !important;
        padding-left: 0 !important;
      }

      &:nth-of-type(2n + 1) {
        &.price-input {
          &::after {
            right: 21px;
          }
        }
      }

      &:nth-of-type(2n) {
        &.price-input {
          &::before {
            left: 21px;
          }
        }
      }      
    }
    
    &.hidden {
      display: none;
    }
  }

  .dateInput {
      margin-bottom: 16px;
      flex-basis: 100%;
      max-width: 100%;
      box-sizing: border-box;
  }
  
  .addons {
    &__total {
      margin-top: 20px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .price-total {        
        font-size: 18px;
      }
    }
  }

  /* Styles for the price fields */
  .price-field {
    width: 100%;
    border: 1px solid ${baseGray200};
    border-radius: 6px;
    padding: 8px 12px;
    background-color: #f9fafb;
    margin-top: 5px;
    box-sizing: border-box;

    &__row {
      display: flex;
      justify-content: space-between;
    }

    &__column {
      width: 100%;
    }

    &__prices {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &__range {
      font-size: 14px;
      display: flex;
      flex-direction: column;
      width: 50%;

      .price-range-value {
        line-height: 38px;
        text-align: left;
        font-size: 16px;
      }

      .price-range-label {
        font-weight: bold;
        font-size: 14px;
        color: #6b7280;
        margin: 0;
        margin-bottom: 4px;
      }
    }

    &__input {
      display: flex;
      flex-direction: column;
      width: 45%;

      .price-field-label {
        font-weight: bold;
        font-size: 14px;
        color: #6b7280;
        margin: 0;
        margin-bottom: 4px;
      }

      .price-input input{
        padding-right: 10px;
      }

      .price-input::after {
        content: none;
      }
    }
  }

  /* Styles for the included services component */
  .included-services {
    width: 100%;
    border: 1px solid ${baseGray200};
    border-radius: 6px;
    padding: 8px;
    background-color: #f9fafb;
    box-sizing: border-box;

    &__list {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 6px;
    }

    &__item {
      padding: 4px 0;
    }

    &__checkbox {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      background-color: #34D399;
      color: white;
      border-radius: 50%;
      margin-right: 8px;
      font-size: 12px;
      font-weight: bold;
    }
  }
`;
